import '@mui/x-data-grid/themeAugmentation'
import type { Components, Theme } from '@mui/material/styles'
import { colorTokens } from '../tokens/colorTokens'
import { typographyTokens } from '../tokens/typographyTokens'


export const dataGridTheme: Components<Theme> = {
    MuiCheckbox: {
        defaultProps: {
            size: 'small',
        },
    },
    MuiDataGrid: {
        defaultProps: {
            density: 'standard',
        },
        styleOverrides: {
            toolbar: ({ theme }) => ({
                flex: '0 0 auto',
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
                justifyContent: 'flex-end',
                height: 'auto',
                minHeight: 0,
                gap: theme.spacing(1),
                padding: theme.spacing(1),
                borderBottom: `1px solid ${theme.palette.divider}`,
                '& .MuiTextField-root': {
                    margin: 0,
                },
                '& .MuiOutlinedInput-root': {
                    ...theme.typography.body2,
                    minHeight: theme.sizing.control.regular,
                },
                '& .MuiOutlinedInput-input': {
                    paddingBlock: theme.spacing(0.5),
                },
                '& .MuiInputAdornment-positionStart': {
                    margin: 0,
                    paddingRight: theme.spacing(0.5),
                    '& .MuiSvgIcon-root': {
                        fontSize: theme.typography.body1.fontSize,
                        color: theme.palette.text.secondary,
                    },
                },
            }),
            root: ({ theme }) => ({
                width: '100%',
                height: '100%',
                minWidth: 0,
                minHeight: 0,
                lineHeight: 1.5,
                '& .MuiDataGrid-actionsCell button[role="menuitem"]': {
                    width: theme.sizing.control.regular,
                    height: theme.sizing.control.regular,
                    padding: theme.spacing(0.25),
                    color: theme.palette.text.secondary,
                    '& .MuiSvgIcon-root': { fontSize: '1rem' },
                    '&:hover:not(:disabled):not(.Mui-disabled)': {
                        color: theme.palette.text.primary,
                        borderColor: theme.palette.text.primary,
                        backgroundColor: theme.palette.action.hover,
                    },
                    '&:disabled, &.Mui-disabled': {
                        color: theme.palette.text.disabled,
                        opacity: 0.6,
                        cursor: 'not-allowed',
                        pointerEvents: 'auto',
                        '&:hover, &:active': {
                            color: theme.palette.text.disabled,
                            borderColor: 'transparent',
                            backgroundColor: 'transparent',
                            boxShadow: 'none',
                        },
                        '& .MuiSvgIcon-root, & .MuiSvgIcon-root:hover': {
                            color: 'inherit',
                        },
                    },
                    '&:focus, &:focus-visible': {
                        outline: 'none',
                        border: 'none',
                        boxShadow: 'none',
                    },
                },
                '&& .MuiDataGrid-row.MuiDataGrid-row--editing > .MuiDataGrid-cell': {
                    backgroundColor: colorTokens.surface.editing,
                },
                '&& .MuiDataGrid-row.MuiDataGrid-row--editing:hover > .MuiDataGrid-cell': {
                    backgroundColor: colorTokens.surface.editing,
                },
                '&& .MuiDataGrid-row--editing .MuiDataGrid-cell--editable': {
                    fontStyle: 'italic',
                },
                '&& .MuiDataGrid-cell.MuiDataGrid-cell--editing:focus-within': {
                    outline: 'none',
                    boxShadow: 'none',
                    backgroundColor: theme.palette.action.hover,
                },
            }),
            cell: ({ theme }) => ({
                padding: theme.spacing(1),
                display: 'flex',
                alignItems: 'center',
                '&:focus, &:focus-within': {
                    outline: 'none',
                    boxShadow: 'none',
                    backgroundColor: theme.palette.action.hover,
                },
            }),
            columnHeader: ({ theme }) => ({
                fontWeight: typographyTokens.fontWeight.bold,
                '&:focus, &:focus-within': {
                    outlineColor: theme.palette.action.hover,
                    backgroundColor: theme.palette.action.hover,
                },
            }),
        },
    },
}
